function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState, useRef } from 'react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { LogOut } from 'lucide-react';
import { Settings } from 'lucide-react';
import { ChevronDown } from 'lucide-react';
import { AuthorDisplay } from '@edusense/shared-ui';
import { DropdownMenu, DropdownMenuItem } from '@edusense/shared-ui-kit';
// useAuth import 제거 - 순환 참조 방지를 위해 onLogout props 사용
import { Avatar } from '@edusense/shared-ui-kit';
import { ProfilePreviewContainer, TabletProfileButton, DropdownUserInfo, DesktopButtonWrapper, ChevronIcon } from './UserProfilePreview.styles';
/**
 * 사용자 프로필 미리보기 컴포넌트
 * 
 * 사이드바 하단에 표시되는 로그인한 사용자 정보와 로그아웃 버튼을 포함합니다.
 * AuthorDisplay 컴포넌트를 활용하여 일관된 사용자 정보 표시 방식을 유지합니다.
 * 태블릿 뷰에서는 프로필 이미지만 표시되며 클릭 시 드롭다운 메뉴가 나타납니다.
 */ var UserProfilePreview = function(param) {
    var user = param.user, onLogout = param.onLogout, onSettingsClick = param.onSettingsClick, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, _param_isVSCodeEnv = param.isVSCodeEnv, isVSCodeEnv = _param_isVSCodeEnv === void 0 ? false : _param_isVSCodeEnv, _param_isTabletView = param.isTabletView, isTabletView = _param_isTabletView === void 0 ? false : _param_isTabletView;
    if (!user) return null;
    var _useState = _sliced_to_array(useState(false), 2), isDropdownOpen = _useState[0], setIsDropdownOpen = _useState[1];
    var profileRef = useRef(null);
    var triggerRef = useRef(null);
    var handleLogout = function() {
        setIsDropdownOpen(false);
        onLogout();
    };
    var toggleDropdown = function() {
        setIsDropdownOpen(function(prev) {
            return !prev;
        });
    };
    // 이미지 소스 정규화: profileImage 우선, 다음 avatar, 그 외는 undefined
    // 표준화된 매핑 사용: auth 레이어에서 OIDC picture -> profileImage로 동기화됨
    // 필요 시 avatar만 보조로 사용
    var sourceProfileImage = user.profileImage && user.profileImage.trim() !== '' ? user.profileImage : user.avatar && user.avatar.trim() !== '' ? user.avatar : undefined;
    // placeholder 이미지 제외
    var filteredProfileImage = sourceProfileImage && !sourceProfileImage.includes('via.placeholder.com') ? sourceProfileImage : null;
    var _user_name, _user_name1, _user_name2;
    return /*#__PURE__*/ React.createElement(ProfilePreviewContainer, {
        ref: profileRef,
        className: "".concat(className, " ").concat(isVSCodeEnv ? 'vscode-profile-preview' : '', " ").concat(isTabletView ? 'tablet-view' : ''),
        "data-testid": "user-profile-preview"
    }, isTabletView ? // 태블릿 뷰 - 프로필 이미지만 표시
    /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement(TabletProfileButton, {
        ref: triggerRef,
        onClick: toggleDropdown,
        "data-testid": "tablet-profile-button"
    }, /*#__PURE__*/ React.createElement(Avatar, {
        username: user.username,
        name: (_user_name = user.name) !== null && _user_name !== void 0 ? _user_name : '',
        profileImage: filteredProfileImage !== null && filteredProfileImage !== void 0 ? filteredProfileImage : undefined,
        size: "md",
        border: "none"
    })), /*#__PURE__*/ React.createElement(DropdownMenu, {
        isOpen: isDropdownOpen,
        onClose: function() {
            return setIsDropdownOpen(false);
        },
        triggerRef: triggerRef,
        width: "12rem",
        "data-testid": "user-profile-dropdown"
    }, /*#__PURE__*/ React.createElement(DropdownUserInfo, {
        "data-testid": "dropdown-user-info"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "user-name"
    }, (_user_name1 = user.name) !== null && _user_name1 !== void 0 ? _user_name1 : ''), /*#__PURE__*/ React.createElement("div", {
        className: "user-username"
    }, "@", user.username)), /*#__PURE__*/ React.createElement(DropdownMenuItem, {
        onClick: function() {
            onSettingsClick();
            setIsDropdownOpen(false);
        },
        icon: /*#__PURE__*/ React.createElement(Settings, {
            size: 16
        }),
        "data-testid": "settings-menu-item"
    }, "설정"), /*#__PURE__*/ React.createElement(DropdownMenuItem, {
        onClick: function() {
            handleLogout();
        },
        icon: /*#__PURE__*/ React.createElement(LogOut, {
            size: 16
        }),
        variant: "danger",
        "data-testid": "logout-menu-item"
    }, "로그아웃"))) : // 데스크톱 뷰 - 전체 정보 표시
    /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement(DesktopButtonWrapper, {
        ref: triggerRef,
        onClick: toggleDropdown,
        "data-testid": "desktop-profile-button"
    }, /*#__PURE__*/ React.createElement(AuthorDisplay, {
        author: {
            id: user.id.toString(),
            name: (_user_name2 = user.name) !== null && _user_name2 !== void 0 ? _user_name2 : '',
            username: user.username,
            profileImage: filteredProfileImage !== null && filteredProfileImage !== void 0 ? filteredProfileImage : undefined
        },
        size: "sm"
    }), /*#__PURE__*/ React.createElement(ChevronIcon, null, /*#__PURE__*/ React.createElement(ChevronDown, {
        size: 20
    }))), /*#__PURE__*/ React.createElement(DropdownMenu, {
        isOpen: isDropdownOpen,
        onClose: function() {
            return setIsDropdownOpen(false);
        },
        triggerRef: triggerRef,
        width: "12rem",
        "data-testid": "user-profile-dropdown"
    }, /*#__PURE__*/ React.createElement(DropdownMenuItem, {
        onClick: function() {
            onSettingsClick();
            setIsDropdownOpen(false);
        },
        icon: /*#__PURE__*/ React.createElement(Settings, {
            size: 16
        }),
        "data-testid": "settings-menu-item"
    }, "설정"), /*#__PURE__*/ React.createElement(DropdownMenuItem, {
        onClick: function() {
            handleLogout();
        },
        icon: /*#__PURE__*/ React.createElement(LogOut, {
            size: 16
        }),
        variant: "danger",
        "data-testid": "logout-menu-item"
    }, "로그아웃"))));
};
export default UserProfilePreview;
